
export class Discount {
  id ?: number;
  'number_of_members': number;
  'discount_fee_name_first_cond': string;
  'discount_fee_name_second_cond': string;
  'money_value'?: number;
  'percent_value'?: number;
  'second_condition_added'?: boolean;
}
